import { setAnnouncedComponentMessage } from '../actions/setAnnouncedComponentMessage';
import { orchestrator } from 'satcheljs';

/*
This orchestrator is used to remove the Announced component since Announced component works only when there is a change.
For example, when the Announced component is created, or, when its message property is changed, hence we need to remove it
once it gets rendered, otherwise, the Narrator won't read the alert text next time since there is no change triggered.
We give React 2 seconds to react to the state change it is listening to. Then it will re-render and remove the Announced
component so that a new component could be created next time when an attachment is added/deleted and then the Narrator
can read the alert text as expected.
*/
export default orchestrator(setAnnouncedComponentMessage, async actionMessage => {
    const { attachmentWell, message } = actionMessage;
    if (message !== null) {
        setTimeout(() => {
            setAnnouncedComponentMessage(attachmentWell, null);
        }, 2000);
    }
});
